import { Component, OnInit } from '@angular/core';
import { DynamicForm } from '../../models/dynamic.form';
import { SelectItems } from '../../../../shared/Models/SelectItems';
import { FormMAsterService } from '../../services/formMaster.service';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-update-form',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateFormComponent implements OnInit {
  dForm: DynamicForm = {} as DynamicForm;
  activityTypesOptions: SelectItems[];
  finish = false;
  dformId: number;
  constructor(
    private service: FormMAsterService,
    private router: Router,
    private diag: NbDialogRef<UpdateFormComponent>,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
    this.loadRequiredCreateDate();
  }
  loadRequiredCreateDate() {
    this.service.getUpdate(this.dformId).subscribe((res) => {
      this.dForm = res.entity;
      this.finish = true;
      //  this.activityTypesOptions = res[0].values;
    });
  }

  save() {
    this.service.put(this.dformId, this.dForm).subscribe((res) => {
      this.toast.success(`Update form ${this.dForm.title} successfully`, 'success', { duration: 4000 });

      this.diag.close('true');
    });
  }
}
